import api from "./ApiClient";

const BASE_PATH_PAYMENTS = '/foodz/api/v1/payments';

class PaymentService {
  static async getSavedCards(foodzUserId, clientCode) {
    const response = await api.get(`${BASE_PATH_PAYMENTS}/cards/${foodzUserId}`, { params: { clientCode } });
    return response.data;
  }

  static async getIntegrationStatus(clientCode) {
    const response = await api.get(`${BASE_PATH_PAYMENTS}/integration`, { params: { clientCode } });
    return response.data;
  }

  static async createCreditRecharge(payload) {
    const response = await api.post('/foodz/api/v1/financeiro/recarga', payload);
    return response.data;
  }

  static async getPixQrCode(rechargeId) {
    const response = await api.get(`${BASE_PATH_PAYMENTS}/pix/${rechargeId}`);
    return response.data;
  }

  /**
   * Confirms a pending payment (ORDER or CREDIT_RECHARGE) using an alternative payment method.
   * Cancels the original Asaas charge (if applicable) and records the new method.
   * @param {{ entityType: string, entityId: string, clientCode: string, newPaymentMethod: string, reasonNote?: string }} payload
   */
  static async confirmAlternativePayment(payload) {
    const response = await api.post(`${BASE_PATH_PAYMENTS}/confirm-alternative`, payload);
    return response.data;
  }

  /**
   * Solicita manualmente o reembolso de um pagamento online (Asaas).
   * O operador é identificado pelo token JWT no backend.
   * @param {{ entityType: string, entityId: string, entityNumericId: number, clientCode: string }} payload
   * @returns {Promise<RefundDTO>}
   */
  static async requestRefund(payload) {
    const response = await api.post(`${BASE_PATH_PAYMENTS}/refund`, payload);
    return response.data;
  }

  /**
   * Retenta um reembolso que está em status FAILED.
   * @param {number} refundId  ID do registro na tabela refunds
   * @param {string} clientCode
   * @returns {Promise<RefundDTO>}
   */
  static async retryRefund(refundId, clientCode) {
    const response = await api.post(
      `${BASE_PATH_PAYMENTS}/refunds/${refundId}/retry`,
      null,
      { params: { clientCode } }
    );
    return response.data;
  }

  /**
   * Consulta o status do reembolso mais recente para uma entidade.
   * Retorna null se nenhum reembolso foi solicitado ainda (404).
   * @param {'ORDER'|'CREDIT_RECHARGE'} entityType
   * @param {string} entityId  foodzOrderId
   * @param {string} clientCode
   * @returns {Promise<RefundDTO|null>}
   */
  static async getRefundStatus(entityType, entityId, clientCode) {
    try {
      const response = await api.get(`${BASE_PATH_PAYMENTS}/refunds/entity`, {
        params: { entityType, entityId, clientCode },
      });
      return response.data;
    } catch (err) {
      if (err.response?.status === 404) return null;
      throw err;
    }
  }

  /**
   * Lista paginada de reembolsos da escola.
   * @param {string} clientCode
   * @param {{ status?: string, offset?: number, limit?: number }} options
   * @returns {Promise<{ content: RefundDTO[], totalElements: number }>}
   */
  static async listRefunds(clientCode, { status, offset = 0, limit = 20 } = {}) {
    const response = await api.get(`${BASE_PATH_PAYMENTS}/refunds`, {
      params: { clientCode, status, offset, limit },
    });
    return response.data;
  }
}

export default PaymentService;